import React, { Component } from 'react'
import classNames from 'classnames'
import analyticsUtils from '../../../helpers/analytics-utils'
import style from './index.module.scss'

import TopRowCategory from './top-row-category'
import SubRowCategory from './sub-row-category'

const topCategories = [
  {
    name: "Women's",
    link: '/products/womens-fashion-accessories',
    id: 'womens-fashion-accessories',
    image:
      '//res.cloudinary.com/scentre-group-au/image/upload/v1528250106/C1-womens-fashion-accessories_t0j67j.jpg',
    alt: 'Womens',
  },
  {
    name: "Men's",
    link: '/products/mens-fashion-accessories',
    id: 'mens-fashion-accessories',
    image:
      '//res.cloudinary.com/scentre-group-au/image/upload/v1528250140/C1-mens-fashion-accessories_cylhfj.jpg',
    alt: 'Mens',
  },
  {
    name: "Kids'",
    link: '/products/kids-babies',
    id: 'kids-babies',
    image:
      '//res.cloudinary.com/scentre-group-au/image/upload/v1528250178/C1-kids-babies_ojijyt.jpg',
    alt: 'Kids',
  },
]
const subCategories = [
  {
    name: 'Sports & Recreation',
    link: '/products/sports-fitness',
    id: 'sports-fitness',
    image:
      '//res.cloudinary.com/scentre-group-au/image/upload/v1528250233/C1-sports-fitness_hlqhun.jpg',
    alt: 'Sports & Recreation',
  },
  {
    name: 'Bags & Luggage',
    link: '/products/bags-luggage',
    id: 'bags-luggage',
    image:
      '//res.cloudinary.com/scentre-group-au/image/upload/v1528250259/C1-bags-luggage_vovhgo.jpg',
    alt: 'Bags & Luggage',
  },
  {
    name: 'Beauty & Health',
    link: '/products/beauty-health',
    id: 'beauty-health',
    image:
      '//res.cloudinary.com/scentre-group-au/image/upload/v1528250283/C1-beauty-health_tgj7md.jpg',
    alt: 'Beauty & Health',
  },
  {
    name: 'Homewares',
    link: '/products/home-decor',
    id: 'home-decor',
    image:
      '//res.cloudinary.com/scentre-group-au/image/upload/v1528250305/C1-home-decor_bezwrs.jpg',
    alt: 'Homewares',
  },
  {
    name: 'Tech',
    link: '/products/computers-electronics',
    id: 'computers-electronics',
    image:
      '//res.cloudinary.com/scentre-group-au/image/upload/v1528250326/C1-computers-electronics_p7p6sa.jpg',
    alt: 'Tech',
  },
  {
    name: 'Books',
    link: '/products/books-stationery',
    id: 'books-stationery',
    image:
      '//res.cloudinary.com/scentre-group-au/image/upload/v1528250345/bookssedgfwCurate-Image_d0egdx.jpg',
    alt: 'Books',
  },
]

class CategoriesSplash extends Component {
  componentDidMount() {
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.PRODUCT_IMPRESSION,
      ecommerce: {
        currencyCode: 'AUD',
        impressions: topCategories.concat(subCategories).map(category => ({
          id: category.id,
          name: category.name,
          list: 'Products Category',
        })),
      },
    })
  }

  render() {
    return (
      <div className={style.categoriesSplash}>
        <div className={classNames(style.categories, style.categoriesTop)}>
          {topCategories.map(category => (
            <TopRowCategory
              name={category.name}
              key={category.id}
              id={category.id}
              link={category.link}
              image={category.image}
              alt={category.alt}
            />
          ))}
        </div>
        <div className={classNames(style.categories, style.categoriesMid)}>
          {subCategories.map(category => (
            <SubRowCategory
              name={category.name}
              key={category.id}
              id={category.id}
              link={category.link}
              image={category.image}
              alt={category.alt}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default CategoriesSplash
